import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'comments',
    template: require('./comments.component.html'),
    styles: [require('./comments.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentsComponent {
    @Input()
    public readonly eQueryTextCtrl: FormControl;
    public readonly modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] as string[] }, { 'background': [] as string[] }],          // dropdown with defaults from theme
            [{ 'font': [] as string[] }],
            [{ 'align': [] as string[] }],
            ['clean'],                                         // remove formatting button
            ['link']                         // link and image, video
        ]
    };

    constructor() {
    }
    public getTextFieldClasses(control: FormControl): string[] {
        return control && control.invalid ? ['is-invalid'] : [];
    }

    public onEQueryTextChanged($event: { html: string }) {
        if (this.eQueryTextCtrl) {
            this.eQueryTextCtrl.setValue($event.html);
        }
    }
}
